import React from "react";
import Modal from "@/components/Modal/Modal";
import { Typography } from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
  reason: any;
}

const RejectedReasonModal: React.FC<Props> = ({
  open,
  onClose,
  reason,
}) => {
  return (
    <Modal
      modalOpen={open}
      closeModal={onClose}
      heading="Rejected Reason"
      width="500px"
    //   hideFooter={true}
      hideaddbutton = {true}
    >
      <div style={{
        maxHeight : "15rem",
            overflowY : "auto",
      }}>

        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "6px",
            padding: "10px",
            // background: "#f5f5f5",
            // overflowX : "auto"
            width : "100%",
            wordBreak : "break-word"
          }}
        >
          <p>{reason?.rejectedReason || "No reason provided"}</p>
        </div>

      </div>
    </Modal>
  );
};

export default RejectedReasonModal;